import React from 'react';
import {Redirect} from 'react-router-dom';
import FuseUtils from "../@fuse/FuseUtils";
import {LoginConfig} from "../main/content/login/LoginConfig";
import {DataGroupsConfig} from "../main/content/data-groups/DataGroupsConfig";
import {DefineDataGroupConfig} from "../main/content/define-data-group/DefineDataGroupConfig";
import {QueryScreenConfig} from "../main/content/query/QueryScreenConfig";
import {ResetPasswordConfig} from "../main/content/reset-password/ResetPasswordConfig";
import {ForgotPasswordConfig} from "../main/content/forgot-password/ForgotPasswordConfig";
import {UserManagementConfig} from "../main/content/user-management/UserManagementConfig";
import {InvitedUsersConfig} from "../main/content/invited-users/InvitedUsersConfig";
import {SettingsConfig} from "../main/content/settings/SettingsConfig";
import {SelectAccountConfig} from "../main/content/select-account/SelectAccountConfig";

const routeConfigs = [
    LoginConfig,
    DataGroupsConfig,
    DefineDataGroupConfig,
    QueryScreenConfig,
    ResetPasswordConfig,
    ForgotPasswordConfig,
    UserManagementConfig,
    InvitedUsersConfig,
    SettingsConfig,
    SelectAccountConfig
];

export const routes = [
    ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
    {
        path     : '/',
        component: () => <Redirect to="/data-groups"/>
    }
];



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseRoutesConfig.js